import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { Button, Input, Typography } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import * as XLSX from "xlsx";

/** 🔹 EXTENDED formatter as per requirement (FULL unit support: kg/cm², μS/cm, N·m, m/s, etc.) */
const formatRangeValue = (value) => {
  if (!value || typeof value !== "string") return value;

  if (value.includes("#")) return value;

  const addHashToUnit = (num, unit = "") =>
    unit ? `${num}#${unit.trim()}` : `${num}#`;

  const numPattern = "[\\d.⁰¹²³⁴⁵⁶⁷⁸⁹ᶟ]+";

  return value
    .split(",")
    .map((part) => {
      const cleaned = String(part).trim();

      if (!cleaned) return "";

      // 🔹 RANGE SUPPORT (with optional spaces)
      const rangeRegex = new RegExp(
        `^(${numPattern})\\s*(.*?)\\s*to\\s*(${numPattern})\\s*(.*)$`,
        "i"
      );

      const rangeMatch = cleaned.match(rangeRegex);

      if (rangeMatch) {
        const fromVal = rangeMatch[1];
        const fromUnit = rangeMatch[2];
        const toVal = rangeMatch[3];
        const toUnit = rangeMatch[4];

        const unit = (fromUnit || toUnit || "").trim();

        return `${addHashToUnit(fromVal, unit)}|${addHashToUnit(toVal, unit)}`;
      }

      // 🔹 TOLERANCE
      if (cleaned.includes("±")) {
        const tolMatch = cleaned.match(/^([\d.±]+)\s*(.*)$/);
        if (tolMatch) {
          return addHashToUnit(tolMatch[1], tolMatch[2]);
        }
      }

      // 🔹 SINGLE VALUE
      const singleRegex = new RegExp(`^(${numPattern})\\s*(.*)$`);
      const singleMatch = cleaned.match(singleRegex);

      if (singleMatch) {
        return addHashToUnit(singleMatch[1], singleMatch[2]);
      }

      return cleaned + "#";
    })
    .filter(Boolean)
    .join("||");
};

const ExcelUpload = ({ setExcelArray, buttonName }) => {
  const handleFileUpload = (acceptedFiles) => {
    const fileReader = new FileReader();

    fileReader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const keys = parsedData[0];

      // keys that need formatting
      const FORMAT_KEYS = ["operatingRange", "accuracy", "lc", "ranges","masterrange","masteraccuracy","masterleastcount","masterUncertainty"];

      const result = parsedData.slice(1).map((row) => {
        const obj = {};

        keys.forEach((key, index) => {
          let value = row[index];

        // 🔹 format only specific keys
          if (FORMAT_KEYS.includes(key) && typeof value === "string") {
            value = formatRangeValue(value);
          }

          obj[key] = value;
        });

        return obj;
      });

      setExcelArray(result);
    };

    if (acceptedFiles.length > 0) {
      fileReader.readAsArrayBuffer(acceptedFiles[0]);
    } else {
      toast.error("Something Went Wrong!");
    }
  };

  return (
    <div id="quotation_create_excelUpload_uploadexcel">
      <Input
        id="file-upload-input"
        type="file"
        style={{ display: "none" }}
        onChange={(e) => handleFileUpload(e.target.files)}
      />
      <label htmlFor="file-upload-input">
        <Button variant="contained" component="span">
          {buttonName}
        </Button>
      </label>
    </div>
  );
};

export default ExcelUpload;
